import { render, staticRenderFns } from "./ModalAddForceBadgeLabel.vue?vue&type=template&id=61b1f94f&"
import script from "./ModalAddForceBadgeLabel.vue?vue&type=script&lang=js&"
export * from "./ModalAddForceBadgeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports